import cx from 'classnames';
import type { VoidFunctionComponent } from 'react';

import styles from './LoadingBar.module.less';

type Props = {
  isVisible: boolean;
};

/**
 * A thin animated loading bar. Renders as a 2px-tall element that is
 * transparent when inactive and shows a green shimmer animation when visible.
 * Uses `transform: translateY(-50%)` so it visually overlaps the border
 * of its preceding sibling, appearing as an animated bottom-border.
 */
export const LoadingBar: VoidFunctionComponent<Props> = ({ isVisible }) => (
  <div className={cx(styles.loadingBar, isVisible && styles.loadingBarVisible)} />
);
